export default __webpack_public_path__ + "static/media/banner1.c40ad2fd.jpg";